import React from 'react';
import { Mutation } from '@apollo/client/react/components';

import DeleteIdeaSearchAlert from 'buyside/graphql/mutations/DeleteIdeaSearchAlert';
import UpdateUserIdeaSearchAlert from 'buyside/graphql/mutations/UpdateUserIdeaSearchAlert';

import SavedSearchAlertItem from 'buyside/components/presentation/UserAccount/SavedSearches/savedSearchAlertItem';

const SavedSearchAlertIdeaContainer = ({ alert, addToParentsSoftDelete, ...props }) => {
  const { id, active, display, name } = alert;

  const initialValues = { ideaSearchAlertId: id, active, display };
  const alertNameValues = { ideaSearchAlertId: id, name };

  const criteriaObj = JSON.parse(alert.ideaSavedSearch.criteria);
  delete criteriaObj['ticker'];
  delete criteriaObj['city_id'];

  return (
    <Mutation mutation={UpdateUserIdeaSearchAlert}>
      {mutate => {
        const updateIdeaSearchAlert = args => mutate({ variables: args });
        return (
          <Mutation mutation={DeleteIdeaSearchAlert}>
            {mutate => {
              const deleteIdeaSearchAlert = ideaSearchAlertId =>
                mutate({
                  variables: { ideaSearchAlertId }
                });
              return (
                <SavedSearchAlertItem
                  updateSearchAlert={updateIdeaSearchAlert}
                  handleDeleteSearchAlert={alert => {
                    deleteIdeaSearchAlert(alert.id);
                    addToParentsSoftDelete(alert);
                  }}
                  initialValues={initialValues}
                  criteriaObj={criteriaObj}
                  alertNameValues={alertNameValues}
                  alert={alert}
                  label="Email me about new ideas matching this search"
                  {...props}
                />
              );
            }}
          </Mutation>
        );
      }}
    </Mutation>
  );
};
export default SavedSearchAlertIdeaContainer;
